import { Injectable, NgZone } from '@angular/core';

import { Store } from '@ngrx/store';

import { HubConnection } from '@microsoft/signalr';

import { DeviceSyncStatus } from '@era/locations-sdk';

import { LocationsHubService } from '@era/core';
import { DeviceSyncStatusActions } from '../sub-features/device-sync/device-sync-statuses-store';

@Injectable()
export class DeviceSyncStatusSignalR {
  private readonly hubConnection: HubConnection;

  constructor(
    private readonly zone: NgZone,
    locationsHubService: LocationsHubService,
    private readonly store: Store<DeviceSyncStatus>
  ) {
    this.hubConnection = locationsHubService.hubConnection;
    this.initialize();
  }

  private initialize() {
    this.hubConnection.on('OnDeviceSyncStatusChanged', (deviceSyncStatusChangedEvent: DeviceSyncStatus) => {
      this.zone.run(() => {
        this.store.dispatch(
          DeviceSyncStatusActions.SignalRActions.statusChanged({ status: deviceSyncStatusChangedEvent })
        );
      });
    });
  }
}
